import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import TransHistoryList from './TransHistoryList';

@inject('commonStore','transStore')
@observer
class TransHistory extends Component {

  UNSAFE_componentWillMount() {
    this.props.transStore.setCommonStoreInfo(this.props.commonStore);
    this.props.transStore.onClear();
    this.props.transStore.disOrderDetail(1);
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <TransHistoryList 
        cGbn={sessionLoginInfo?.cGbn || ""}
        ceType={sessionLoginInfo?.ceType || ""}
      />
    );
  }
}

export default withRouter(TransHistory);
